import React from "react";
import { IoIosMore } from "react-icons/io";
import UserAvatar from "../../components/UserAvatar";

const ChatHeader = ({
  selectedTicket,
  showMoreMenu,
  toggleMoreMenu,
  moreMenuRef,
  handleStatusChange,
  handleDeleteTicket,
}) => {
  if (!selectedTicket) return null;

  return (
    <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-[#F4F5F6]">
      <div className="flex items-center overflow-hidden">
        <div className="flex-shrink-0 mr-4">
          <UserAvatar
            user={selectedTicket?.userId}
            variant="square"
            useInitials={true}
            bgColor="black"
          />
        </div>
        <div className="flex flex-col min-w-0">
          <span className="text-sm font-semibold truncate">
            {selectedTicket?.subject}
          </span>
          <div className="text-sm text-gray-500 font-light line-clamp-1">
            {selectedTicket?.message}
          </div>
        </div>
      </div>

      <div className="relative flex items-center ml-4">
        <button
          className="p-1 hover:bg-gray-200 rounded-full transition-colors"
          onClick={() => toggleMoreMenu("original")}
        >
          <IoIosMore className="w-5 h-5 text-black cursor-pointer" />
        </button>

        {showMoreMenu === "original" && (
          <div
            ref={moreMenuRef}
            className="absolute right-0 z-10 py-1 bg-white border border-gray-200 rounded shadow-lg top-8 min-w-32"
          >
            <button
              className="w-full text-left px-4 py-2 text-sm font-light hover:bg-gray-100"
              onClick={() => {
                handleStatusChange(selectedTicket._id, "closed");
                toggleMoreMenu(null);
              }}
            >
              Close Ticket
            </button>
            <button
              className="w-full text-left px-4 py-2 text-sm font-light text-red-600 hover:bg-gray-100"
              onClick={() => {
                handleDeleteTicket(selectedTicket._id);
                toggleMoreMenu(null);
              }}
            >
              Delete Ticket
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatHeader;
